import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

import { AuthLayout } from "@/components/layouts";
import { AcceptInvitationForm } from "@/components/features";

export interface AcceptInvitationPageProps {}

export const AcceptInvitationPage: React.FC<AcceptInvitationPageProps> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get invitation ID from URL query parameters
  const invitationId = searchParams.get("token");

  const handleAcceptSuccess = (userData: any) => {
    console.log("Invitation accepted successfully:", userData);
    // Redirect to signin page to let user log in with their new credentials
    navigate("/account/signin");
  };

  // If no invitation ID is provided, show error
  if (!invitationId) {
    return (
      <AuthLayout
        title="Accept Invitation"
        subtitle="Complete your account setup"
      >
        <Alert color="red" icon={<IconAlertCircle size={16} />}>
          Invalid invitation link. Please check your email for the correct link
          or contact your administrator.
        </Alert>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Accept Invitation"
      subtitle="Complete your account setup to join FormSubmits"
    >
      <AcceptInvitationForm
        invitationId={invitationId}
        onAcceptSuccess={handleAcceptSuccess}
      />
    </AuthLayout>
  );
};
